/** Import Node Modules */
import React, { Component } from "react";
import {
  change as ReduxFormChange,
  destroy,
  formValueSelector
} from "redux-form";
/** Import Redux Library */
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import ReactPaginate from "react-paginate";
import {
  calendarResources,
  RemoveItemFromCalendarList,
  postArchivedItems,
  removeSingleArchivedCalendar,
  unArchiveItems
} from "../redux";
/** Import Local Components */
// import CalendarHeader from "../modules/calendarHeader";
import CalendarArchiveTable from "../modules/calendarArchiveTable";
import { Dialog, Tooltip } from "../../../core";
import { Resources as CampaignResources } from "../../campaign/redux";

class Calendar extends Component {
  constructor(props) {
    super(props);
    this.perPageCount = 20;
    calendarResources.getArchivedCalendar.url = `/calendars/archive?page=${1}&per_page=${
      this.perPageCount
    }`;
    this.props.Get(calendarResources.getArchivedCalendar).then(() => {
      this.setState({
        isLoading: false
      });
    });
    this.archiveTableRefs = React.createRef();
    CampaignResources.getCampaign.url = "/campaigns";
    this.props.Get(CampaignResources.getCampaign);

    this.initialSortOrder = {
      name: { active: false, sortBy: "desc" },
      status: { active: false, sortBy: "desc" },
      created_at: { active: false, sortBy: "desc" },
      updated_at: { active: false, sortBy: "desc" }
    };
    this.state = {
      forcePage: undefined,
      sortOrder: this.initialSortOrder,
      isLoading: true,
      sortValue: { isSortable: false },
      deleteModal: {
        id: undefined,
        modal: false,
        body: "Are you sure you want to delete this calendar.",
        title: "Confirm Delete"
      }
    };
  }

  handleSort = name => {
    this.setState({ isLoading: true, forcePage: 0 });
    this.props.ReduxFormChange(
      "SelectedCalendarOnArchive",
      "calendarSelected",
      []
    );
    this.archiveTableRefs.current.selectionContext.selected = [];
    this.archiveTableRefs.current.setState({});
    this.setState(
      prevState => ({
        sortOrder: {
          ...this.initialSortOrder,
          [name]: {
            active: true,
            sortBy: prevState.sortOrder[name].sortBy === "desc" ? "asc" : "desc"
          }
        },
        sortValue: {
          name,
          active: true,
          sortBy: prevState.sortOrder[name].sortBy === "desc" ? "asc" : "desc",
          isSortable: true
        }
      }),
      () => {
        const { getArchivedCalendar } = calendarResources;
        getArchivedCalendar.url = `/calendars/archive/?sort=${name}&sort_by=${
          this.state.sortOrder[name].sortBy
        }&page=${1}&per_page=${this.perPageCount}`;
        this.props
          .Get(getArchivedCalendar)
          .then(() => this.setState({ isLoading: false }));
      }
    );
  };

  handleUnArchiveItem = id => {
    const { unArchiveCalendar } = calendarResources;
    unArchiveCalendar.body = unArchiveItems({ filteredCalendarId: [id] });
    this.props.Put(unArchiveCalendar).then(() =>
      this.props.Get(calendarResources.getArchivedCalendar).then(result => {
        if (result.status === 200) {
          return (
            this.props.calendarsList.length === 0 &&
            this.handlePageClick(this.props.meta, true)
          );
        }
      })
    );
  };

  handleUnArchiveItems = () => {
    const { unArchiveCalendar } = calendarResources;
    const filteredCalendarId = this.props.selectedCalendar.map(item => item.id);
    unArchiveCalendar.body = unArchiveItems({ filteredCalendarId });
    this.props
      .Put(unArchiveCalendar)
      .then(() =>
        this.props.Get(calendarResources.getArchivedCalendar).then(result => {
          if (result.status === 200) {
            return (
              this.props.calendarsList.length === 0 &&
              this.handlePageClick(this.props.meta, true)
            );
          }
        })
      )
      .then(() =>
        this.props.ReduxFormChange(
          "SelectedCalendarOnArchive",
          "calendarSelected",
          []
        )
      )
      .then(() => {
        this.archiveTableRefs.current.selectionContext.selected = [];
        this.archiveTableRefs.current.setState({});
      });
  };

  handleDeleteConfirmation = id => {
    const { deleteModal } = this.state;
    deleteModal.modal = true;
    deleteModal.id = id;
    deleteModal.body = (
      <span>
        <span>Are you sure you want to delete? </span>
        {/* <strong>{name}</strong>? */}
      </span>
    );

    this.setState({ deleteModal });
  };

  handleDelete = () => {
    const { deleteModal } = this.state;
    const filteredCalendarId = this.props.selectedCalendar.map(item => item.id);
    const { removeBulkCalendar } = calendarResources;
    if (deleteModal.id) {
      removeBulkCalendar.body = removeSingleArchivedCalendar(deleteModal.id);
    } else {
      removeBulkCalendar.body = postArchivedItems({ filteredCalendarId });
    }
    this.props
      .Put(removeBulkCalendar)
      .then(() => {
        this.props.Get(calendarResources.getArchivedCalendar).then(result => {
          if (result.status === 200) {
            return (
              this.props.calendarsList.length === 0 &&
              this.handlePageClick(this.props.meta, true)
            );
          }
        });
        deleteModal.modal = false;
        deleteModal.id = undefined;
        this.setState({
          deleteModal
        });
      })
      .then(() =>
        this.props.ReduxFormChange(
          "SelectedCalendarOnArchive",
          "calendarSelected",
          []
        )
      )
      .then(() => {
        this.archiveTableRefs.current.selectionContext.selected = [];
        this.archiveTableRefs.current.setState({});
      })
      .then(() => this.handlePageClick(this.props.meta, true));
  };
  /**
   * @param {id}  calendar id
   */

  toggleModel = flag => {
    const { deleteModal } = this.state;
    deleteModal.modal = flag;
    this.setState({ deleteModal });
  };

  handlePageClick = (data, moveToPrevious = false) => {
    window.scrollTo(0, 0);
    this.setState({ isLoading: true });
    const { getArchivedCalendar } = calendarResources;
    if (moveToPrevious) {
      getArchivedCalendar.url = `/calendars/archive?page=${data.page -
        1}&per_page=${this.perPageCount}`;
      this.props.Get(getArchivedCalendar).then(() => {
        this.setState({ forcePage: data.page - 2, isLoading: false });
      });
    } else {
      this.setState({ forcePage: undefined });
      this.setState({ isLoading: true });
      const { selected } = data;
      if (this.state.sortValue.isSortable) {
        getArchivedCalendar.url = `/calendars/archive?sort=${
          this.state.sortValue.name
        }&sort_by=${this.state.sortValue.sortBy}&page=${selected +
          1}&per_page=${this.perPageCount}`;
      } else {
        getArchivedCalendar.url = `/calendars/archive?page=${selected +
          1}&per_page=${this.perPageCount}`;
      }
      this.props
        .Get(getArchivedCalendar)
        .then(() => this.setState({ forcePage: selected, isLoading: false }));
    }
  };

  render() {
    const { deleteModal } = this.state;
    return (
      <div className="contentwrapper">
        <div className="d-flex mb-2 pr-0 contentheader networkFixedHeader">
          <h3 className="p-0 mr-auto mt-2">Archived Calendars</h3>
          {this.props.selectedCalendar.length > 0 && (
            <div className="d-flex">
              {" "}
              <Tooltip
                item={
                  <div className="content-refresh ml-2">
                    <div
                      role="presentation"
                      className="fas fa-history dropdown dropdown--filter"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.handleUnArchiveItems();
                      }}
                    />
                  </div>
                }
                tooltipContent="Restore"
                id="unarchive-content"
              />
              <Tooltip
                item={
                  <div className="content-refresh ml-2">
                    <div
                      role="presentation"
                      className="fa fa-trash"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.handleDeleteConfirmation();
                      }}
                    />
                  </div>
                }
                tooltipContent="Delete"
                id="delete-archive-content"
              />
            </div>
          )}
        </div>
        <Dialog
          externalControl
          showHandler={false}
          modal={deleteModal.modal}
          body={deleteModal.body}
          title={deleteModal.title}
          toggleModel={this.toggleModel}
          primaryMethod={this.handleDelete}
        />
        <CalendarArchiveTable
          {...this.props}
          forwardRef={this.archiveTableRefs}
          handleDelete={this.handleDeleteConfirmation}
          handleChange={this.handleChange}
          handlePause={this.handlePause}
          handleSort={this.handleSort}
          sortOrder={this.state.sortOrder}
          handleDuplicate={this.handleDuplicate}
          isLoading={this.state.isLoading}
          calendarsList={this.props.calendarsList}
          handleUnArchiveItem={this.handleUnArchiveItem}
        />
        {!this.state.isLoading &&
          this.props.calendarsList &&
          this.props.calendarsList.length > 0 && (
            <ReactPaginate
              pageCount={this.props.meta ? this.props.meta.totalPages : 0}
              pageRangeDisplayed={3}
              onPageChange={this.handlePageClick}
              marginPagesDisplayed={2}
              activeClassName="activePage"
              containerClassName="contentPagination"
              subContainerClassName="pages pagination"
              previousLabel="Previous"
              forcePage={this.state.forcePage}
              nextLabel="Next"
              breakLabel="..."
              breakClassName="break-me"
              disabledClassName="paginationDisable"
            />
          )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { list, status, loading, hasError, meta } = state.archiveCalendars;
  const selector = formValueSelector("SelectedCalendarOnArchive");
  return {
    calendarsList: list !== undefined ? list : [],
    selectedCalendar: selector(state, "calendarSelected") || [],
    loading,
    hasError,
    meta,
    status
  };
}

export default connect(
  mapStateToProps,
  { RemoveItemFromCalendarList, ReduxFormChange, destroy }
)(Calendar);
